import { FORM_ID } from 'src/models/FormModel';
import { ErrorBag } from 'src/models/ErrorModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { useRef } from 'react';
import NotificationEmailToolbar from 'src/components/DatagridToolbar/entities/NotificationEmailToolbar';
import Debug from 'src/lib/Debug';
// eslint-disable-next-line import/no-extraneous-dependencies
import { RichTextEditor, RichTextEditorRef } from 'mui-tiptap';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Editor } from '@tiptap/core';
import useExtensions from 'src/lib/useExtention';
import { makeStyles } from '@material-ui/core';
import InvitationEmailToolbar from '../InvitationEmailToolbar';

interface Props {
  disabled?: boolean,
  form: FORM_ID,
  label?: string,
  name: string,
  onChange: (value: any, field: any) => void,
  toolbar?: string;
  value: string,
  height?: string,
}

interface Param {
  editor: Editor,
}

const useStyles = (height?: string) => makeStyles({
  editorWrapper: {
    '& .ProseMirror': {
      minHeight: height,
      maxHeight: height,
      overflowY: 'auto',
      outline: 'none',
    },
  },
});

const FormRichTextEditor = (props: Props) => {
  const {
    disabled, form, label, name, onChange, value, toolbar, height,
  } = props;
  const classes = useStyles(height)();

  const extensions = useExtensions({
    placeholder: label,
  });

  const getToolbar = () => {
    switch (toolbar) {
      case 'invitation':
        return <InvitationEmailToolbar />;
      default:
        return <NotificationEmailToolbar />;
    }
  };

  type RichTextEditorRef = typeof RichTextEditorRef;

  const errors: ErrorBag =
    useSelector((state:Store) => state.errors[form] || {} as ErrorBag);

  Debug.log([errors], true);

  const rteRef = useRef<RichTextEditorRef>(null);

  return (
    <div className={classes.editorWrapper}>
      <RichTextEditor
        ref={rteRef}
        extensions={extensions} // Or any Tiptap extensions you wish!
        content="<p></p>" // Initial content for the editor
        onUpdate={({ editor }:Param) => { onChange(editor.getHTML(), name); }}
        renderControls={() => getToolbar()}
        editable={!disabled}
        disabled={disabled}
        disableFocusTrap
        value={value} />
    </div>
  );
};

export default FormRichTextEditor;
//
